export default {
  en: {
    snack: {
      generic_error: 'Something went wrong',
      attend: 'Successfully added to attendee list',
      initial: 'Successfully removed from attendee list',
      can_not_attend: 'Successfully added to cannot go list',
      slots_full: 'Event is full you can not join anymore',
    },
    actions: {
      attend: 'Going',
      can_not_attend: 'Not going',
      withdraw: 'Withdraw',
    },
    status: {
      attend: "I'm going",
      initial: 'Going/Not going',
      can_not_attend: "I can't go",
    },
  },
};
